import React from 'react'
import { PageLoading } from '../PageLoading'
import { Empty } from '../Empty'

interface BaseWhenShowProps {
  when: boolean
  loading?: boolean
  showEmpty?: boolean
  fallback?: React.ReactNode
  children: React.ReactNode
}

/**
 * 显示控制组件
 * @param props
 * @returns
 */
export const WhenShow: React.FC<BaseWhenShowProps> = (props) => {
  const { loading = false, when, showEmpty = false, fallback = null, children } = props

  // 优先判断loading
  if (loading) {
    return <PageLoading />
  }

  // 再次判断 when
  if (when) {
    return children
  }

  // 当when为false时，判断是否需要显示空状态
  if (showEmpty) {
    return <Empty />
  }

  // 数据为空，并且不需要显示空状态时，则显示fallback
  return fallback
}
